import React from 'react'
import styled from 'styled-components'

const Footer = () => {
  return (
    <>
      <Wrapper>
        <div className="container">
          <p>Copyrighy &copy; by MD. Arslan</p>
        </div>

      </Wrapper>
    </>
  )
}

export default Footer

const Wrapper = styled.section`
.container{
    width: 100%;
    height: 60px;
    background-color: rgba(45, 46, 46, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    
}
.container p{
    color: rgba(255, 204, 0, 1);
}

@media (max-width: 768px) {
    .container p{
        font-size: 16px;
    }
}
`
